import React from 'react';
const stats: {
  value: string;
  label: string;
}[] = [{
  value: '+1.200',
  label: 'familias y docentes confían'
}, {
  value: '6',
  label: 'Tomos listos'
}, {
  value: '6',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: '⭐ calificación'
}];
export function TrustBar() {
  return <section aria-label="Prueba social" className="w-full border-y border-navy/10 bg-celeste-light" data-id="element-268" data-mp="137kalm4jwxit">
      <ul className="mx-auto grid max-w-6xl grid-cols-2 gap-y-5 px-5 py-6 sm:grid-cols-4" data-id="element-269" data-mp="1qwv6oqayi3qm">
        {stats.map(stat => <li key={stat.label} className="text-center" data-id="element-270" data-mp="1uxyi90lz1dm1">
            <p className="font-display text-2xl font-extrabold text-navy sm:text-3xl" data-id="element-271" data-mp="1gz79ltpvok5a">
              {stat.value}
            </p>
            <p className="mt-0.5 text-xs font-semibold text-navy/70 sm:text-sm" data-id="element-272" data-mp="1lxiju5k34wo1">
              {stat.label}
            </p>
          </li>)}
      </ul>
    </section>;
}